var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "yd-dialog",
    {
      attrs: {
        title: _vm.form.id ? "编辑" : "新增",
        visible: _vm.showVisible,
        "append-to-body": "",
      },
      on: {
        "update:visible": function ($event) {
          _vm.showVisible = $event
        },
        close: _vm.closeEdit,
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "ruleForm",
          staticStyle: { "margin-left": "30px", "margin-right": "10px" },
          attrs: {
            model: _vm.form,
            rules: _vm.rules,
            size: "mini",
            "label-position": "left",
            "label-width": "110px",
          },
        },
        [
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.type === 4 ? "icon名称" : "广告名称",
                prop: "name",
              },
            },
            [
              _c("el-input", {
                staticStyle: { width: "300px" },
                attrs: {
                  type: "text",
                  placeholder: "不超过" + (_vm.type === 4 ? 5 : 10) + "个字",
                  maxlength: _vm.type === 4 ? 5 : 10,
                  "show-word-limit": "",
                },
                model: {
                  value: _vm.form.name,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "name", $$v)
                  },
                  expression: "form.name",
                },
              }),
            ],
            1
          ),
          _vm.clientType === 1
            ? _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.type === 4 ? "位置" : "广告位置",
                    prop: "locationKey",
                  },
                },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "300px" },
                      attrs: {
                        placeholder: "请选择",
                        disabled: _vm.type === 4,
                        clearable: "",
                      },
                      model: {
                        value: _vm.form.locationKey,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "locationKey", $$v)
                        },
                        expression: "form.locationKey",
                      },
                    },
                    _vm._l(_vm.locationList, function (item) {
                      return _c("el-option", {
                        key: item.advertisingLocationKey,
                        attrs: {
                          label: item.advertisingLocationDesc,
                          value: item.advertisingLocationKey,
                        },
                      })
                    }),
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.type === 3 || _vm.type === 4
            ? _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.type === 4 ? "排序" : "权重",
                    prop: "sort",
                  },
                },
                [
                  _c("el-input", {
                    staticStyle: { width: "300px" },
                    attrs: { type: "number", placeholder: "请输入整数" },
                    model: {
                      value: _vm.form.sort,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "sort", _vm._n($$v))
                      },
                      expression: "form.sort",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-form-item",
            { attrs: { label: "活动时间", required: "" } },
            [
              _c("el-date-picker", {
                staticStyle: { width: "200px" },
                attrs: {
                  format: "yyyy-MM-dd HH:mm:ss",
                  "value-format": "yyyy-MM-dd HH:mm:ss",
                  type: "datetime",
                  placeholder: "开始日期",
                  "picker-options": _vm.pickerOptionStart(),
                },
                model: {
                  value: _vm.form.startTime,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "startTime", $$v)
                  },
                  expression: "form.startTime",
                },
              }),
              _c("span", [_vm._v("-")]),
              _c("el-date-picker", {
                staticStyle: { width: "200px" },
                attrs: {
                  format: "yyyy-MM-dd HH:mm:ss",
                  "value-format": "yyyy-MM-dd HH:mm:ss",
                  type: "datetime",
                  placeholder: "结束日期",
                  "picker-options": _vm.pickerOptionEnd(),
                },
                model: {
                  value: _vm.form.endTime,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "endTime", $$v)
                  },
                  expression: "form.endTime",
                },
              }),
            ],
            1
          ),
          _vm.type !== 1
            ? _c(
                "el-form-item",
                { attrs: { label: "图片", prop: "imgUrl", required: "" } },
                [
                  _vm.type !== 4 || _vm.clientType === 2
                    ? _c(
                        "div",
                        [
                          _c("upload-image", {
                            attrs: {
                              file: _vm.fileList,
                              instructionText:
                                "jpg/png/gif格式，大小" +
                                _vm.imgSize[0] +
                                "*" +
                                _vm.imgSize[1] +
                                "，不超过500kb。",
                              width: _vm.imgSize[0],
                              height: _vm.imgSize[1],
                              fileSize: 500,
                              code: _vm.codeType,
                            },
                            on: {
                              uploadSuccess: function (url) {
                                return _vm.getImgUrl(url)
                              },
                              remove: function ($event) {
                                return _vm.handleRemove("ios")
                              },
                            },
                          }),
                        ],
                        1
                      )
                    : _c(
                        "div",
                        { staticClass: "flex" },
                        [
                          _vm.form.imgUrl
                            ? _c("el-image", {
                                staticStyle: {
                                  width: "100px",
                                  height: "100px",
                                },
                                attrs: {
                                  src: _vm.form.imgUrl,
                                  "preview-src-list": [_vm.form.imgUrl],
                                },
                              })
                            : _vm._e(),
                          _c(
                            "div",
                            { staticClass: "margin-left-10" },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "text" },
                                  on: { click: _vm.changeImg },
                                },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(
                                        _vm.form.imgUrl
                                          ? "更换图片"
                                          : "新增图片"
                                      ) +
                                      "\n          "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                ]
              )
            : _vm._e(),
          _vm.clientType !== 1 && _vm.type === 1
            ? _c(
                "el-form-item",
                {
                  attrs: { label: "Android图片", prop: "imgUrl", required: "" },
                },
                [
                  _c("upload-image", {
                    attrs: {
                      file: _vm.androidFile,
                      instructionText:
                        "jpg/png/gif格式，大小1080*1920，不超过500kb。",
                      width: 1080,
                      height: 1920,
                      code: _vm.codeType,
                    },
                    on: {
                      uploadSuccess: function (url) {
                        return _vm.getImgUrl(url, "android")
                      },
                      remove: function ($event) {
                        return _vm.handleRemove("android")
                      },
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm.clientType !== 1 && _vm.type === 1
            ? _c(
                "el-form-item",
                { attrs: { label: "IOS图片", prop: "imgUrl", required: "" } },
                [
                  _c("upload-image", {
                    attrs: {
                      file: _vm.iosFile,
                      instructionText:
                        "jpg/png/gif格式，大小750*1334，不超过500kb。",
                      width: 750,
                      height: 1334,
                      code: _vm.codeType,
                    },
                    on: {
                      uploadSuccess: function (url) {
                        return _vm.getImgUrl(url, "ios")
                      },
                      remove: function ($event) {
                        return _vm.handleRemove("ios")
                      },
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm.clientType !== 1 && _vm.type === 1
            ? _c(
                "el-form-item",
                { attrs: { label: "自定义图片" } },
                [
                  _vm.customImage.length < 4
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.addCustom },
                        },
                        [_vm._v("添加")]
                      )
                    : _vm._e(),
                  _c(
                    "div",
                    { staticStyle: { display: "flex", "margin-top": "10px" } },
                    _vm._l(_vm.customImage, function (item) {
                      return _c("upload-image", {
                        key: item.uuid,
                        attrs: {
                          file: item.file,
                          instructionText: item.instructionText,
                          code: _vm.codeType,
                        },
                        on: {
                          uploadSuccess: function (url) {
                            return _vm.getImgUrl(url, "custom", item)
                          },
                          remove: function ($event) {
                            return _vm.handleRemove("custom", item)
                          },
                        },
                      })
                    }),
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-form-item",
            {
              attrs: {
                label: "跳转页面",
                prop: _vm.type === 4 ? "pageUrl" : "",
              },
            },
            [
              _c("el-input", {
                staticStyle: { width: "300px" },
                attrs: { placeholder: "请输入链接" },
                model: {
                  value: _vm.form.pageUrl,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.form,
                      "pageUrl",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "form.pageUrl",
                },
              }),
            ],
            1
          ),
          _vm.clientType === 1
            ? _c(
                "el-form-item",
                {
                  attrs: {
                    label: "跳转类型",
                    prop: _vm.type === 4 ? "pageUrlType" : "",
                  },
                },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.form.pageUrlType,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "pageUrlType", $$v)
                        },
                        expression: "form.pageUrlType",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 2 } }, [
                        _vm._v("外部链接"),
                      ]),
                      _c("el-radio", { attrs: { label: 1 } }, [
                        _vm._v("乘客端内部页面"),
                      ]),
                      _c("el-radio", { attrs: { label: 3 } }, [
                        _vm._v("其他小程序（仅在微信小程序生效）"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.form.pageUrlType === 3
            ? _c(
                "el-form-item",
                { attrs: { label: "APPID", prop: "appId" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "300px" },
                    attrs: { placeholder: "请输入APPID" },
                    model: {
                      value: _vm.form.appId,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.form,
                          "appId",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "form.appId",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm.form.pageUrlType === 3
            ? _c(
                "el-form-item",
                { attrs: { label: "账号原始ID", prop: "appletOriginalId" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "300px" },
                    attrs: { placeholder: "请输入账号原始ID" },
                    model: {
                      value: _vm.form.appletOriginalId,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.form,
                          "appletOriginalId",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "form.appletOriginalId",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm.clientType === 1
            ? _c(
                "el-form-item",
                { attrs: { label: "展示渠道", prop: "displayChannelList" } },
                [
                  _c(
                    "el-checkbox-group",
                    {
                      model: {
                        value: _vm.form.displayChannelList,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "displayChannelList", $$v)
                        },
                        expression: "form.displayChannelList",
                      },
                    },
                    [
                      _c("el-checkbox", { attrs: { label: "1" } }, [
                        _vm._v("微信小程序"),
                      ]),
                      _c("el-checkbox", { attrs: { label: "2" } }, [
                        _vm._v("APP"),
                      ]),
                      _c("el-checkbox", { attrs: { label: "3" } }, [
                        _vm._v("云闪付"),
                      ]),
                      _c("el-checkbox", { attrs: { label: "4" } }, [
                        _vm._v("支付宝小程序"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c("el-button", { on: { click: _vm.closeEdit } }, [_vm._v("取 消")]),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.save } },
            [_vm._v("保 存")]
          ),
        ],
        1
      ),
      _vm.imgShow
        ? _c("imageGallery", {
            attrs: { visible: _vm.imgShow },
            on: { closeChoose: _vm.closeChoose, saveImage: _vm.saveImage },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }